// extracted by mini-css-extract-plugin
export var grid = "_f-5";
export var layout = "_f-0";
export var leftColumn = "_f-1";
export var leftInner = "_f-2";
export var rightColumn = "_f-3";
export var rightInner = "_f-4";